// extracted by mini-css-extract-plugin
export var advantages = "advantagesList-module--advantages--1-9S7";
export var jsAnimInit = "advantagesList-module--jsAnimInit--3pfxU";
export var title = "advantagesList-module--title--26hQP";
export var text = "advantagesList-module--text--INUrI";